// ** React Imports
import { useState, useEffect, MouseEvent, useCallback, ReactElement } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import { DataGrid, GridEventListener } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography'
import Icon from 'src/features/common/CustomIcon'
import Link from '@mui/material/Link';
// ** Store Imports
import { SelectOption } from 'src/types/common';
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
// ** Custom Components Imports
import Tooltip from '@mui/material/Tooltip'
import { client } from 'src/utils/axios-client'
import { leadEndpoints } from 'src/configs/endpoints'

import _, { now } from 'lodash'
import { ActivityDialogStore, ActivityType, CadenceListDialogStore, DashboardViewStore, DeleteLeadStore, FilterSingleLead, InboundCallStore, Lead, LeadListStore, LeadOverrideStore, LeadScreenStore, QuickLeadDialogStore, ViewType } from '../../stores/LeadStore'
import { ActivityColor, colorDateTooltipOverdue, colorDateTooltipOverdueDashboard, nextDateDays, nextDateDaysDashboard } from '../../utils/date-utils'
import { DataGridPro } from '@mui/x-data-grid-pro/DataGridPro'
import LeadDataFormater from '../leads/view/LeadDataFormater'
import IconButton from '@mui/material/IconButton';
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';
import DateTimeDisplay from '../common/DateTimeDisplay';
import { red } from '@mui/material/colors';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import CheckIcon from '@mui/icons-material/Check';
import { error } from 'console';
import GridSkeleton from '../common/GridSkeleton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import OverrideMenu from './OverrideMenu';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import RenderIf, { ClaimType, ClaimValue } from '../common/RenderIf';
import RenderIfNot from '../common/RenderIfNot';
import LeadGridView from '../leads/list/LeadGridView';
import { Filter, FilterType, OptionWithSelect } from '../filters/FilterTypes';
import { useAuth } from '../../hooks/useAuth';

type Props = {
    activityDate: string,
    startDate: string,
    endDate: string,
    userId: string,
    title: string,
    activityId: string,
}

const ActivityWorkList = ({ activityDate, startDate, endDate, userId, title, activityId }: Props) => {
    const { user } = useAuth();
    //const [pageSize, setPageSize] = useState(50);
    //const [value, setValue] = useState<string>('')
    //const showTodoList = DashboardViewStore.useState(s => s.showTodoList);    

    const [filter, setFilter] = useState<Filter>({
        id: '',
        description: '',
        searchTerm: '',
        startDate: startDate !== '' ? startDate : undefined,
        endDate: endDate !== '' ? endDate : undefined,
        activityDate,
        hasNextActivity: true,
        filterType: FilterType.User,
        options: [{
            optionType: 'OWNER',
            value: userId !== '' ? userId : user?.id,
            name: '',
            inclusive: true
        } as OptionWithSelect,
        {
            optionType: 'ACTIVITY_TYPES',
            value: activityId,
            name: '',
            inclusive: true
        } as OptionWithSelect
        ]
    });

    useEffect(() => {
        //setHasLoaded(false);
        //loadRecords(pageNumber, pageSize, activityDate, startDate, endDate, userId, activityName);
    }, [activityDate, startDate, endDate, userId, activityId])

    //const loadRecords = async (pageNumber: number, pageSize: number, activityDate: string, startDate: string, endDate: string, userId: string, activityName: string) => {
    //    const response = await client.get(leadEndpoints.getActivityLeads, { params: { pageNumber: pageNumber + 1, pageSize, activityDate, startDate, endDate, userId, activityName } });
    //    LeadListStore.update(s => { s.list = response.data });
    //    setHasLoaded(true);

    //}

    const goBack = () => {
        DashboardViewStore.update(s => { s.activityDate = '' });
        DashboardViewStore.update(s => { s.showTodoList = true });
        DashboardViewStore.update(s => { s.showActivityWorkList = false });
        DashboardViewStore.update(s => { s.showInboundCallList = false });
        DashboardViewStore.update(s => { s.showDefault = true });
        DashboardViewStore.update(s => { s.showDetail = false });
        DashboardViewStore.update(s => { s.showTaskList = false });
    };

    return (
        <LeadGridView searchTerm='' filter={filter}>
            <Box>
                <Tooltip title="Go Back" >
                    <IconButton aria-label="Go Back to Dashboard" onClick={() => goBack()} >
                        <ArrowBackTwoToneIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <Box>
                <Typography variant="h6" sx={{ color: 'CornflowerBlue' }} gutterBottom>
                    {title}
                </Typography>
            </Box>
        </LeadGridView>
    )


}

export { ActivityWorkList }
export default ActivityWorkList
